/* import __COLOCATED_TEMPLATE__ from './paywall.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();